export const ZONES_BASE_PATH = {
  smart: '/smart-zone',
  satV1: '/sat-v1-zone',
  satV2: '/sat-v2-zone',
  satV3: '/sat-v3-zone',
  satV4: '/sat-v4-zone',
  satV5: '/sat-v5-zone',
  content: '/content-zone',
  managementInformation: '/management-information-zone',
  communication: '/communication-zone',
  comms: '/comms-zone',
  contact: '/contact-zone',
  challenge: '/challenge-zone',
  timeTable: '/time-table-zone',
  workflow: '/workflow-zone',
  defaultSchoolZone: '/school-zone',
  satModule: '/sat-module',
};
